import {HttpClient, HttpResponse} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import { RequestType } from '../shared/enums/requestType';


@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  private httpClient=inject(HttpClient);

  public BASE_URL: string = environment.BACK_END_POINT;
  public BASE_OPEN_API_URL: string = this.BASE_URL + 'open-api/';
  public API_URL: string = 'api';

  public call(method: RequestType, url: string, ...args: any[]): Observable<any> {
    switch (method) {
      case RequestType.GET: return this.httpClient.get<any>(url, args[0]);
      case RequestType.POST: return this.httpClient.post<any>(url, args[0], args[1]);
      case RequestType.PUT: return this.httpClient.put<any>(url, args[0], args[1]);
      case RequestType.DELETE: return this.httpClient.delete<any>(url, { responseType: 'text', ...args[0] });
      default: throw new Error(`Unsupported request method: ${method}`);
    }
  }

  public callResponse<T>(method: RequestType, url: string, body?: any, options?: any): Observable<HttpResponse<T>> {
    const { observe: _ignoreObserve, reportProgress: _ignoreRp, ...safe } = options || {};
    switch (method) {
      case RequestType.GET: return this.httpClient.get<T>(url, { ...safe, observe: 'response' as const }) as Observable<HttpResponse<T>>;
      case RequestType.POST: return this.httpClient.post<T>(url, body, { ...safe, observe: 'response' as const }) as Observable<HttpResponse<T>>;
      case RequestType.PUT: return this.httpClient.put<T>(url, body, { ...safe, observe: 'response' as const }) as Observable<HttpResponse<T>>;
      case RequestType.DELETE: return this.httpClient.delete<T>(url, { ...safe, observe: 'response' as const, responseType: 'text' as any }) as Observable<HttpResponse<T>>;
      default: throw new Error('Unsupported method');
    }
  }

}
